import { createFileRoute } from '@tanstack/react-router';

import { OrderEditPage } from '../order/edit/OrderEditPage';

export const Route = createFileRoute('/_app/order_/edit/$id')({
    component: OrderEditPage,
});
